export const SIGN_IN = "admin/api/auth/login";
export const SIGN_UP = "api/auth/signup";
export const GET_ALL_USERS = "admin/api/users/all"; 
export const UPDATE_USER = "admin/api/users"; 
export const GET_USER = "admin/api/users"; 
export const GET_HEADER_CONTENT = "admin/api/header"; 


// models category
export const GET_ALL_CATEGORIES = "admin/api/model-category/all"; 
export const ADD_CATEGORIES = "admin/api/model-category/add"; 
export const UPDATE_CATEGORIES = "admin/api/model-category/update"; 
export const REMOVE_CATEGORIES = "admin/api/model-category/remove";

// models subcategory
export const GET_ALL_SUBCATEGORIES = "admin/api/model-subcategory/all"; 
export const ADD_SUBCATEGORIES = "admin/api/model-subcategory/add"; 
export const UPDATE_SUBCATEGORIES = "admin/api/model-subcategory/update"; 
export const REMOVE_SUBCATEGORIES = "admin/api/model-subcategory/remove";

// models assets
export const GET_ALL_MODELS = "admin/api/models/all"; 
export const ADD_MODELS = "admin/api/models/add"; 
export const UPDATE_MODELS = "admin/api/models/update"; 
export const REMOVE_MODELS = "admin/api/models/remove";
// export const UPDATE_USER = "/api/user/update";
// export const DELETE_USER = "/api/user/remove";
// export const GET_ALL_CATEGORIES = "/api/categories"; 
// export const ADD_CATEGORIES = "/api/categories/add"; 
// export const UPDATE_CATEGORIES = "/api/categories/update"; 
// export const REMOVE_CATEGORIES = "/api/categories/remove"; 
// export const GET_ALL_USERS_PROFILE = "/api/profiles"; 
// export const USER_PROFILES_UPDATE = "/api/profiles/update"; 
// export const USER_PROFILES_REMOVE = "/api/profiles/remove"; 
// export const GET_PROFILE_QUESTIONS = "/api/profiles-questions/all"; 
// export const UPDATE_PROFILE_QUESTIONS = "/api/profiles-questions/update"; 
// export const ADD_PROFILE_QUESTIONS = "/api/profiles-questions/add"; 
// export const GET_CONTENTS = "/api/contents"; 